import CheckboxInput from '@/Components/UI/Form/CheckboxInput/CheckboxInput';

export const Option = ({
  option,
  handleCheckboxValuesChange,
  multipleValue,
  filteredOptions,
  index,
  style,
}) => {
  const currentOption = option ? option : filteredOptions[index];
  return (
    <div
      style={style}
      key={index}
      className='flex items-center !w-fit min-w-[230px] pl-2 pr-2 text-sm cursor-pointer text-ui hover:bg-ocean-blue-100 hover:text-ui hover:rounded hover:w-auto whitespace-nowrap'
    >
      <div className='flex items-center cursor-pointer'>
        <CheckboxInput
          labelClassName='text-xs'
          label={currentOption === '' ? '(Blanks)' : currentOption}
          checked={multipleValue.includes(currentOption)}
          onChange={(event) => {
            handleCheckboxValuesChange(event, currentOption);
          }}
          className='cursor-pointer'
          dataCy={`qf-option-${currentOption.toLowerCase()}`}
        />
      </div>
    </div>
  );
};
